import React from "react";

export default function DialogHead({ text, subtext, icon }) {
    return (
        <div className="dialog-head-component">
            { icon && icon }
            <span>
                { text }
            </span>
            { subtext && <span className="subtext">{` (${subtext})`}</span> }
        </div>
    );
};